export const FETCH_INVITATIONS_LIST_START = 'FETCH_INVITATIONS_LIST_START';
export const FETCH_INVITATIONS_LIST_ERROR = 'FETCH_INVITATIONS_LIST_ERROR';
export const RECEIVE_INVITATIONS_LIST = 'RECEIVE_INVITATIONS_LIST';
export const CLEAR_INVITATIONS_LIST_STORE = 'CLEAR_INVITATIONS_LIST_STORE';

export const FETCH_INVITATION_DETAILS_START = 'FETCH_INVITATION_DETAILS_START';
export const RECEIVE_INVITATION_DETAILS = 'RECEIVE_INVITATION_DETAILS';
export const FETCH_INVITATION_DETAILS_NOT_FOUND = 'FETCH_INVITATION_DETAILS_NOT_FOUND';
export const FETCH_INVITATION_DETAILS_ERROR = 'FETCH_INVITATION_DETAILS_ERROR';
export const CLEAR_INVITATION_DETAILS_STORE = 'CLEAR_INVITATION_DETAILS_STORE';

export const SEND_INVITATION_START = 'SEND_INVITATION_START';
export const SEND_INVITATION_ERROR = 'SEND_INVITATION_ERROR';
export const SEND_INVITATION_SUCCESSFUL = 'SEND_INVITATION_SUCCESSFUL';

export const DELETE_INVITATION_START = 'DELETE_INVITATION_START';
export const DELETE_INVITATION_ERROR = 'DELETE_INVITATION_ERROR';
export const DELETE_INVITATION_SUCCESSFUL = 'DELETE_INVITATION_SUCCESSFUL';

export const RESEND_INVITATION_START = 'RESEND_INVITATION_START';
export const RESEND_INVITATION_ERROR = 'RESEND_INVITATION_ERROR';
export const RESEND_INVITATION_SUCCESSFUL = 'RESEND_INVITATION_SUCCESSFUL';
export const CANCEL_INVITATION_START = 'CANCEL_INVITATION_START';
export const CANCEL_INVITATION_ERROR = 'CANCEL_INVITATION_ERROR';
export const CANCEL_INVITATION_SUCCESSFUL = 'CANCEL_INVITATION_SUCCESSFUL';

export const FETCH_INVITATION_PRE_ACCEPT_START = 'FETCH_INVITATION_PRE_ACCEPT_START';
export const FETCH_INVITATION_PRE_ACCEPT_ERROR = 'FETCH_INVITATION_PRE_ACCEPT_ERROR';
export const FETCH_INVITATION_PRE_ACCEPT_NOT_FOUND = 'FETCH_INVITATION_PRE_ACCEPT_NOT_FOUND';
export const RECEIVE_INVITATION_PRE_ACCEPT = 'RECEIVE_INVITATION_PRE_ACCEPT';
export const CLEAR_INVITATION_PRE_ACCEPT_STORE = 'CLEAR_INVITATION_PRE_ACCEPT_STORE';

export const INVITATION_ACCEPT_START = 'INVITATION_ACCEPT_START';
export const INVITATION_ACCEPT_ERROR = 'INVITATION_ACCEPT_ERROR';
export const INVITATION_ACCEPT_SUCCESSFUL = 'INVITATION_ACCEPT_SUCCESSFUL';
export const CLEAR_INVITATION_ACCEPT_STORE = 'CLEAR_INVITATION_ACCEPT_STORE';

export const ADD_INVITATION_TO_INVITATIONS_LIST = 'ADD_INVITATION_TO_INVITATIONS_LIST';
export const REMOVE_INVITATION_FROM_INVITATIONS_LIST = 'REMOVE_INVITATION_FROM_INVITATIONS_LIST';
export const UPDATE_INVITATION_IN_INVITATIONS_LIST = 'UPDATE_INVITATION_IN_INVITATIONS_LIST';



// WEBPACK FOOTER //
// ./src/store/modules/invitations/mutation-types.js